import { Group, Text } from '@optiaxiom/react';

import { formatTimestamp } from '../../../utils';

type TimestampCellProps = {
  createdAt: Date;
};

export function TimestampCell({ createdAt }: TimestampCellProps) {
  const { time, date } = formatTimestamp(createdAt);

  return (
    <Group flexDirection="column" gap="0">
      <Text fontSize="sm">{time}</Text>
      <Text fontSize="sm" color="fg.tertiary">
        {date}
      </Text>
    </Group>
  );
}
